import { memo, useEffect } from 'react';
import { useAnimatedStyle, useSharedValue, withDelay, withTiming } from 'react-native-reanimated';
import { Box, Image, Text } from '@bonanza-social/moonlight';
import { DEFAULT_ANIMATION_DELAY, DEFAULT_ANIMATION_DURATION } from '../RewardReceivedBottomSheet.content';

function QuestCompleted() {
  const animatedValueScale = useSharedValue(0);
  const animatedValueOpacity = useSharedValue(1);
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{
      scale: animatedValueScale.value,
    }],
    opacity: animatedValueOpacity.value,
    pointerEvents: 'none',
  }));

  useEffect(() => {
    animatedValueScale.value = withDelay(DEFAULT_ANIMATION_DELAY, withTiming(1, {
      duration: DEFAULT_ANIMATION_DURATION,
    }));
    animatedValueOpacity.value = withDelay(
      DEFAULT_ANIMATION_DELAY + DEFAULT_ANIMATION_DURATION,
      withTiming(0, {
        duration: DEFAULT_ANIMATION_DURATION,
      })
    );
  }, [animatedValueScale, animatedValueOpacity]);

  return (
    <Box animatedStyle={animatedStyle} centerContent absoluteFill>
      <Image name="common.GreenCheck" width={60} height={60} />
      <Text
        variant="h4"
        locNS="rewards"
        locKey="questCompleted"
        paddingTop='space-200'
        color="accentSurfaceSecondary"
        textAlign="center"
        maxWidth={200}
      />
    </Box>
  );
}

export default memo(QuestCompleted);
